package com.xtream.ui.tv.presentation.widget


/**
 * [NavigationDrawerScope] is used to provide the doesNavigationDrawerHaveFocus state to the
 * [NavigationDrawerItem] composable
 */
interface NavigationDrawerScope {
    /** Whether any item within the [NavigationDrawer] or [ModalNavigationDrawer] is focused */
    @get:Suppress("GetterSetterNames") val hasFocus: Boolean
}

internal class NavigationDrawerScopeImpl(override val hasFocus: Boolean) : NavigationDrawerScope